import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@fontsource/inter/variable.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import 'material-symbols/outlined.css';
import './globals.css';
import './i18n';

createRoot(document.getElementById('root')!).render(<App />);
